<header
  class="ui-app-header"
  role="banner"
  [class.ui-app-header--loading]="loading()"
  [class.ui-app-header--portal]="variant() === 'portal'"
  [class.ui-app-header--consultation]="variant() === 'consultation'"
>
  <div class="ui-app-header__inner">
    <div class="ui-app-header__start">
      @if (logoSrc()) {
        @if (logoHref()) {
          <a
            class="ui-app-header__logo-link"
            [href]="logoHref()!"
            [attr.target]="logoHrefTarget()"
            [attr.rel]="logoHrefRel() ?? (logoHrefTarget() === '_blank' ? 'noopener noreferrer' : null)"
          >
            <img
              class="ui-app-header__logo-img"
              [src]="logoSrc()!"
              [alt]="logoAlt()"
              height="25"
              loading="eager"
            />
          </a>
        } @else {
          <button
            type="button"
            class="ui-app-header__logo-btn"
            (click)="onLogoClick($event)"
          >
            <img
              class="ui-app-header__logo-img"
              [src]="logoSrc()!"
              [alt]="logoAlt()"
              height="25"
              loading="eager"
            />
          </button>
        }
      } @else if (variant() === 'system') {
        <div class="ui-app-header__logo-slot">
          <ng-content select="[data-ui-app-header-logo]" />
        </div>
      }

      <div
        class="ui-app-header__nav-slot"
        [class.ui-app-header__nav-slot--with-divider]="
          variant() !== 'system' && !!logoSrc() && !!navTitle()
        "
      >
        @if (showMenuToggle() && variant() !== 'consultation') {
          <button
            type="button"
            class="ui-app-header__toolbar-btn ui-app-header__menu-toggle-btn"
            [disabled]="loading()"
            [attr.aria-label]="menuToggleTooltip()"
            [uiTooltip]="menuToggleTooltip()"
            uiTooltipPosition="bottom"
            [uiTooltipDisabled]="loading()"
            (click)="onMenuToggleClick()"
          >
            <img
              class="ui-app-header__toolbar-icon"
              [src]="menuToggleIconSrc()"
              alt=""
              width="20"
              height="20"
              aria-hidden="true"
            />
          </button>
        }
        @if (navTitle() || mobileNavTitle()) {
          @if (navTitle()) {
            <span class="ui-app-header__nav-title ui-app-header__nav-title--default">
              {{ navTitle() }}
            </span>
          }
          @if (mobileNavTitle()) {
            <span class="ui-app-header__nav-title ui-app-header__nav-title--mobile">
              {{ mobileNavTitle() }}
            </span>
          }
        } @else if (variant() === 'system') {
          <ng-content select="[data-ui-app-header-nav]" />
        }
      </div>
    </div>

    <div class="ui-app-header__end">
      <div
        class="ui-app-header__end-start"
        [class.ui-app-header__end-start--hidden]="
          !showCompanyFilter() || variant() === 'consultation'
        "
      >
        <ng-content select="[data-ui-app-header-end-start]" />
      </div>
      @if (variant() === 'system' || showNotification() || messagesVisible()) {
      <div class="ui-app-header__toolbar" role="toolbar" aria-label="Acciones de cabecera">
        @if (variant() === 'system') {
          @if (showHome()) {
            <button
              type="button"
              class="ui-app-header__toolbar-btn"
              [disabled]="loading()"
              [attr.aria-label]="homeTooltip()"
              [uiTooltip]="homeTooltip()"
              uiTooltipPosition="bottom"
              [uiTooltipDisabled]="loading()"
              (click)="onHomeClick()"
            >
              <img
                class="ui-app-header__toolbar-icon"
                [src]="homeIconSrc()"
                alt=""
                width="20"
                height="20"
                aria-hidden="true"
              />
            </button>
          }
          @if (showAiAssistant()) {
            <button
              type="button"
              class="ui-app-header__toolbar-btn"
              [disabled]="loading()"
              [attr.aria-label]="aiAssistantTooltip()"
              [uiTooltip]="aiAssistantTooltip()"
              uiTooltipPosition="bottom"
              [uiTooltipDisabled]="loading()"
              (click)="onAiAssistantClick()"
            >
              <img
                class="ui-app-header__toolbar-icon"
                [src]="aiAssistantIconSrc()"
                alt=""
                width="20"
                height="20"
                aria-hidden="true"
              />
            </button>
          }
          @if (showSearch()) {
            <button
              type="button"
              class="ui-app-header__toolbar-btn"
              [disabled]="loading()"
              [attr.aria-label]="searchTooltip()"
              [uiTooltip]="searchTooltip()"
              uiTooltipPosition="bottom"
              [uiTooltipDisabled]="loading()"
              (click)="onSearchClick()"
            >
              <img
                class="ui-app-header__toolbar-icon"
                [src]="searchIconSrc()"
                alt=""
                width="20"
                height="20"
                aria-hidden="true"
              />
            </button>
          }
          @if (showDocuments()) {
            <button
              type="button"
              class="ui-app-header__toolbar-btn"
              [disabled]="loading()"
              [attr.aria-label]="documentsTooltip()"
              [uiTooltip]="documentsTooltip()"
              uiTooltipPosition="bottom"
              [uiTooltipDisabled]="loading()"
              (click)="onDocumentsClick()"
            >
              <img
                class="ui-app-header__toolbar-icon"
                [src]="documentsIconSrc()"
                alt=""
                width="20"
                height="20"
                aria-hidden="true"
              />
            </button>
          }
          @if (showDigitalSignature()) {
            <button
              type="button"
              class="ui-app-header__toolbar-btn"
              [disabled]="loading()"
              [attr.aria-label]="digitalSignatureTooltip()"
              [uiTooltip]="digitalSignatureTooltip()"
              uiTooltipPosition="bottom"
              [uiTooltipDisabled]="loading()"
              (click)="onDigitalSignatureClick()"
            >
              <img
                class="ui-app-header__toolbar-icon"
                [src]="digitalSignatureIconSrc()"
                alt=""
                width="20"
                height="20"
                aria-hidden="true"
              />
            </button>
          }
        }
        @if (messagesVisible()) {
          <button
            type="button"
            class="ui-app-header__toolbar-btn"
            [disabled]="loading()"
            [attr.aria-label]="messagesTooltip()"
            [uiTooltip]="messagesTooltip()"
            uiTooltipPosition="bottom"
            [uiTooltipDisabled]="loading()"
            (click)="onMessageClick()"
          >
            <img
              class="ui-app-header__toolbar-icon"
              [src]="messagesIconSrc()"
              alt=""
              width="20"
              height="20"
              aria-hidden="true"
            />
            @if (badgeLabel(messageCount()); as count) {
              <span class="ui-app-header__badge" aria-hidden="true">{{ count }}</span>
            }
          </button>
        }
        @if (showNotification()) {
          <button
            type="button"
            class="ui-app-header__toolbar-btn ui-app-header__toolbar-btn--notify"
            [disabled]="loading() || notificationDisabled()"
            [attr.aria-disabled]="loading() || notificationDisabled()"
            [attr.aria-invalid]="notificationError() ? 'true' : null"
            [attr.aria-label]="notificationLabel()"
            [uiTooltip]="notificationTooltip()"
            uiTooltipPosition="bottom"
            [uiTooltipDisabled]="loading() || notificationDisabled()"
            [attr.aria-expanded]="notificationItems().length ? notificationMenuOpen() : null"
            [attr.aria-haspopup]="notificationItems().length ? 'dialog' : null"
            cdkOverlayOrigin
            #notificationTrigger="cdkOverlayOrigin"
            (click)="onNotificationClick($event)"
          >
            <img
              class="ui-app-header__toolbar-icon"
              [src]="notificationIconSrc()"
              alt=""
              width="20"
              height="20"
              aria-hidden="true"
            />
            @if (badgeLabel(notificationCount()); as count) {
              <span class="ui-app-header__badge" aria-hidden="true">{{ count }}</span>
            }
          </button>
          <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayOrigin]="notificationTrigger"
            [cdkConnectedOverlayOpen]="notificationMenuOpen()"
            [cdkConnectedOverlayPositions]="profileOverlayPositions"
            [cdkConnectedOverlayScrollStrategy]="notificationScrollStrategy"
            [cdkConnectedOverlayPush]="true"
            [cdkConnectedOverlayViewportMargin]="16"
            [cdkConnectedOverlayHasBackdrop]="true"
            [cdkConnectedOverlayBackdropClass]="'ui-app-header__menu-backdrop'"
            (backdropClick)="notificationMenuOpen.set(false)"
          >
            <ui-notification-menu
              [items]="notificationItems()"
              (itemSelect)="onNotificationItem($event)"
              (viewAll)="onNotificationViewAll()"
            />
          </ng-template>
        }
      </div>
      }

      <div class="ui-app-header__user">
        @if (loading()) {
          <ui-avatar [loading]="true" size="md" shape="circle" />
        } @else if (userAvatarSrc() || userAvatarLabel() || userAvatarIconSrc()) {
          <button
            type="button"
            class="ui-app-header__user-btn"
            cdkOverlayOrigin
            #userMenuTrigger="cdkOverlayOrigin"
            [disabled]="userDisabled()"
            [attr.aria-label]="userAvatarAlt()"
            [attr.aria-expanded]="showProfileMenu() ? userMenuOpen() : null"
            [attr.aria-haspopup]="showProfileMenu() ? 'dialog' : null"
            [uiTooltip]="userAvatarTooltip()"
            uiTooltipPosition="bottom"
            [uiTooltipDisabled]="userDisabled()"
            (click)="toggleUserMenu($event)"
          >
            <ui-avatar
              [imageSrc]="userAvatarSrc()"
              [iconSrc]="userAvatarIconSrc()"
              [label]="userAvatarLabel()"
              [imageAlt]="userAvatarAlt()"
              [ariaLabel]="userAvatarAlt()"
              size="md"
              shape="circle"
            />
          </button>

          @if (showProfileMenu()) {
            <ng-template
              cdkConnectedOverlay
              [cdkConnectedOverlayOrigin]="userMenuTrigger"
              [cdkConnectedOverlayOpen]="userMenuOpen()"
              [cdkConnectedOverlayPositions]="profileOverlayPositions"
              [cdkConnectedOverlayScrollStrategy]="profileScrollStrategy"
              [cdkConnectedOverlayHasBackdrop]="true"
              [cdkConnectedOverlayBackdropClass]="'ui-app-header__menu-backdrop'"
              (backdropClick)="onBackdropClick()"
            >
              <ui-user-profile-menu
                [variant]="variant() === 'system' ? 'system' : 'portal'"
                [title]="profileMenuTitle()"
                [userName]="profileUserName()"
                [userRole]="profileUserRole()"
                [userEmail]="profileUserEmail()"
                [avatarSrc]="userAvatarSrc()"
                [avatarLabel]="userAvatarLabel()"
                [avatarIconSrc]="userAvatarIconSrc()"
                [avatarAlt]="userAvatarAlt() || profileUserName()"
                [items]="variant() === 'consultation' ? [] : profileMenuItems()"
                [logoutLabel]="profileLogoutLabel()"
                (itemSelect)="onProfileItemSelect($event)"
                (logout)="onProfileLogout()"
              />
            </ng-template>
          }
        } @else {
          <ng-content select="[data-ui-app-header-user]" />
        }
      </div>
    </div>
  </div>
</header>
